import React from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
	Card,
	Button, Modal, ModalBody, FormGroup,Row
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import Select, {components} from 'react-select'
import countryList from 'react-select-country-list'
import TimeZoneField from '../../components/people/timeZoneField'
import './client-location-edit.scss'
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import { auth } from '../../Api';
import { leaveForm } from '../../utils/formReturn'
import EditButtons, { markChanged } from '../../components/forms/editButtons'
import { getName } from 'country-list';
import { PIN_HINT, SITE_ZOOM, pinRefusal, roundedSpot, startCountry, typedSpot, geocodeCountry, countryFromPinNote,
  zoneChangeMessage } from '../../utils/locationPin'
import PlaceSearch from '../../components/maps/placeSearch'

export function CountryFlag(props) {
    return (
      <span
        className={"flag-icon flag-icon-" + props.code}
        style={{ fontSize: props.size || "30px" }}
      />
    );
  }
  
  export const CountryFlagSelectOption = props => {
    return (
      <components.Option {...props}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <CountryFlag size={props.flagSize} code={props.value.toLowerCase()} />
          {props.label}
        </div>
      </components.Option>
    );
  };
  
  export const CountryFlagValueContainer = ({ children, ...props }) => {
    const code = (props.hasValue && props.getValue()[0].value) || false;
  
    return (
      <div style={{ display: "flex", flexGrow: 1 }}>
        {(code && <CountryFlag code={code.toLowerCase()} />) || null}
        <components.ValueContainer {...props}>
          {children}
        </components.ValueContainer>
      </div>
    );
  };

const styles = {
    valueContainer: (base, state) => {
      const height = "35px";
      return { ...base, height };
    }
};

class CompanyView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked:false,
			open: false,
			modal: false,
			obj: {},
			jsonData: [],
			data: data.makeData(),
			treedata: data.treedata,
      options: countryList().getData(),
      timeOptions:[],
      nameValue: "",
      timeValue: '',
      countryValue:null,
      // A new location: no spot until the map has opened on its country (src/utils/locationPin.js)
      latitude:'',
      longitude:'',
      address:'',
      zoom: 1,
      locationId:null,
      // A new location is not saved until its pin has been dragged or the map clicked; an existing one has its spot
      pinMoved:false,

      showAlert:false,
			showResult:false,

      markers: []
		};
    this.toggle = this.toggle.bind(this);
    this.onPick = this.onPick.bind(this);
    this.map = null;
	}
  componentDidMount(){
    const {id} = this.props.match.params
    this.setState({
      locationId:id
    })
    if(id=='null'){
      // The account's country, else the client's: the Country field (which can be changed, and follows the pin) and
      // where the map opens
      let clientId = localStorage.getItem('clientId')
      let companyId = localStorage.getItem('companyId')
      const country = (request) => request.then((res) => res.data.code == 200 && res.data.message.users[0] ? res.data.message.users[0].countrycode : null).catch(() => null)
      Promise.all([country(auth.getCompany({ id: companyId })), country(auth.getClient({id:clientId, company_id: companyId}))])
        .then(([companyCountry, clientCountry]) => {
          const code = startCountry(companyCountry, clientCountry)
          if (this.unmounted || !code || this.state.countryValue) {
            return
          }
          this.setState({ countryValue: {value:code, label:getName(code)} })
          this.fitCountry(code)
        });
    }

    if(id!='null'){
      let timeValue=""
      let req = {}
      req.id = id
      auth.getLocation(req)
        .then((res)=>{
          console.log("res:",res)
          let jsonData=res.data.message.users[0]
          timeValue = {value:jsonData.timezone, label:jsonData.timezone}
          this.setState({
            locationId: id,
            nameValue:jsonData.name,
            address:jsonData.address,
            latitude:jsonData.latitude,
            longitude:jsonData.longitude,
            countryValue:{value:jsonData.countrycode,label:getName(jsonData.countrycode)},
            timeValue:timeValue,
            // Its saved pin, which can also be dragged
            pinMoved:true
          })
          const spot = typedSpot(jsonData.latitude, jsonData.longitude)
          if (spot) {
            this.setState({ markers: [this.pin(spot)] })
            this.showSpot(spot)
            // A location saved with another country than its pin's (and so the wrong time zone) is put right
            this.countryFromPin(spot)
          }
        })
    }

  }

  // The location's own country follows its pin (Google's geocoder looks the spot up): its time zone comes from that
  // country and the pin. Left as it is when Google cannot tell (no map yet, the sea, no answer).
  countryFromPin(spot){
    if (!this.map || !this.props.google) {
      this.pendingPinCountry = spot
      return
    }
    this.pendingPinCountry = null
    new this.props.google.maps.Geocoder().geocode({ location: spot }, (results, status) => {
      const code = status === 'OK' ? geocodeCountry(results) : null
      if (this.unmounted || !code || (this.state.countryValue && this.state.countryValue.value === code)) {
        return
      }
      this.setState({ countryValue: { value: code, label: getName(code) }, countryNote: countryFromPinNote(getName(code) || code) })
      // A correction to save
      markChanged(this)()
    })
  }

  // The search box above the map (components/maps/placeSearch.js): a suggestion picked while typing, or what was typed
  // looked up with Google's geocoder (Find, or Enter). The map goes there with the pin, which can then be dragged, and
  // the country follows the pin.
  goToPlace = (geometry, formattedAddress) => {
    const spot = roundedSpot(geometry.location.lat(), geometry.location.lng())
    if (this.map) {
      if (geometry.viewport) {
        this.map.fitBounds(geometry.viewport)
      }
      this.map.setCenter(spot)
      this.map.setZoom(SITE_ZOOM)
    }
    this.movePin(spot.lat, spot.lng)
    // An empty Address takes the place's address
    this.setState((state) => ({ address: state.address ? state.address : (formattedAddress || '') }))
  }

  componentWillUnmount(){
    this.unmounted = true
  }

  pin(spot){
    return { title: "The exact spot of the site", name: "SITE", position: { lat: spot.lat, lng: spot.lng } }
  }

  // The map is ready: open it where the page has got to (the country of a new location, the pin of an existing one)
  onMapReady = (mapProps, map) => {
    this.map = map
    // The search box biases its suggestions to what the map shows
    this.setState({ map })
    if (this.pendingPinCountry) {
      this.countryFromPin(this.pendingPinCountry)
    }
    if (this.pendingSpot) {
      this.showSpot(this.pendingSpot)
    } else if (this.pendingCountry) {
      this.fitCountry(this.pendingCountry)
    }
  }

  showSpot(spot){
    if (!this.map) {
      this.pendingSpot = spot
      return
    }
    this.pendingSpot = null
    this.map.setCenter(spot)
    this.map.setZoom(SITE_ZOOM)
  }

  // A new location whose pin has not been moved: the map fitted to the country (Google's geocoder, with the
  // country code) and the pin at its centre. Left as it is if Google cannot find the country.
  fitCountry(code){
    if (!code) {
      return
    }
    if (!this.map || !this.props.google) {
      this.pendingCountry = code
      return
    }
    this.pendingCountry = null
    new this.props.google.maps.Geocoder().geocode({ address: getName(code) || code, componentRestrictions: { country: code } }, (results, status) => {
      if (this.unmounted || status !== 'OK' || !results || !results[0] || this.state.pinMoved) {
        return
      }
      const geometry = results[0].geometry
      if (geometry.viewport) {
        this.map.fitBounds(geometry.viewport)
      } else {
        this.map.setCenter(geometry.location)
      }
      const spot = roundedSpot(geometry.location.lat(), geometry.location.lng())
      this.setState({ latitude: spot.lat, longitude: spot.lng, markers: [this.pin(spot)] })
    })
  }

  // Dragging the pin, clicking the map or typing the coordinates: the pin and Latitude / Longitude follow
  movePin(lat, lng){
    const spot = roundedSpot(lat, lng)
    this.setState({ latitude: spot.lat, longitude: spot.lng, markers: [this.pin(spot)], pinMoved: true })
    markChanged(this)()
    this.countryFromPin(spot)
  }

    onPick(t, map, coord) {
      const { latLng } = coord;
      this.movePin(latLng.lat(), latLng.lng())
    }

  onPinDragged = (props, marker, event) => {
    if (event && event.latLng) {
      this.movePin(event.latLng.lat(), event.latLng.lng())
    }
  }

  // Leaving without saving (Exit edit page, Discard changes), or after the time zone note: back where the form was
  // opened from, or the client's locations
  exitForm = () => {
    leaveForm(this.props.history, '/client-location/' + localStorage.getItem('clientId'))
  }

    toggle() {
		this.setState({
		  showAlert: !this.state.showAlert
		});
	  }

    changeCountry = value => {
      console.log("countryValue:",value);
        this.setState({
          countryValue: value,
          countryNote: '',
      });
      markChanged(this)()
      // A new location whose pin has not been moved yet: the map and pin go to that country
      if (this.state.locationId == "null" && !this.state.pinMoved && value && value.value) {
        this.fitCountry(value.value)
      }
    };
    changeTimezone = value =>{
      console.log("timezone:",value)
      this.setState({timeValue:value});
    }
    onSave=(event)=>{
      event.preventDefault();
      let {nameValue,address,latitude,longitude,timeValue,locationId,countryValue} = this.state
      console.log("address:",address)
      let alertMessage = "";
      var client_id = localStorage.getItem('clientId')
      var req = {}
      req.name = nameValue
      req.address = address
      const pinError = pinRefusal(locationId == "null", this.state.pinMoved)
      if (pinError) {
        this.setState({
          showAlert:true,
          showResult:false,
          alertMessage:pinError
          })
        return
      }
      if(address=='' || address==null){
        alertMessage='Address cannot be empty.\n'
        this.setState({
          showAlert:true,
          showResult:false,
          alertMessage:alertMessage
          })
        return
      }
      if(!timeValue || !timeValue.value){
        alertMessage = 'Please choose the time zone: the country has several.\n'
        this.setState({
          showAlert:true,
          showResult:false,
          alertMessage:alertMessage
          })
        return
      }
      if(!countryValue || !countryValue.value){
        alertMessage='Please wait for the page to finish loading, then try saving again.\n'
        this.setState({
          showAlert:true,
          showResult:false,
          alertMessage:alertMessage
          })
        return
      }
      req.latitude = latitude.toString()
      req.longitude = longitude.toString()
      req.countrycode = countryValue.value
      req.timezone = timeValue.value
      req.client_id = client_id
      var that = this;
      if(locationId=="null")
      auth.registerLocation(req)
        .then((res)=>{
          console.log("res:",res);
          if(res.data.message!=null){
            if(res.data.code==400)
            {
              if(res.data.message.name!=null){
              alertMessage+='The name already registered.\n'
              }
              if(res.data.message.phone!=null){
              alertMessage+='This phone number already exists\n'
              }
              // The country or time zone (the server's own words)
              for (const field of ['countrycode', 'timezone']) {
                if (Array.isArray(res.data.message[field])) {
                  alertMessage += res.data.message[field][0] + '\n'
                }
              }
              that.setState({
              showAlert:true,
              showResult:false,
              alertMessage:alertMessage
              })
            }
            else if(res.data.code==201)
            {
              // Back to the page the form was opened from, or the client's locations
              leaveForm(that.props.history, '/client-location/' + client_id)
            }
          }
        });
      else 
        {
          req.id = locationId
          auth.updateLocation(req)
            .then((res)=>{
              console.log(res)
              if(Number(res.data.code)===201){
                // A new time zone with duties still to come: the admin is told first (their stored times are unchanged)
                const zoneMessage = zoneChangeMessage(res.data.message && res.data.message.zone_change)
                if (zoneMessage) {
                  that.setState({ zoneMessage })
                  return
                }
                // Back to the page the form was opened from, or the client's locations
                leaveForm(that.props.history, '/client-location/' + client_id)
              }
              else {
                // It used to say "Updated Successfully" whatever the reply
                const fieldError = res.data.message && ['countrycode', 'timezone'].map((field) => Array.isArray(res.data.message[field]) ? res.data.message[field][0] : null).find(Boolean)
                const error = (res.data.message && res.data.message.error) || fieldError
                that.setState({
                  showAlert:true,
                  showResult:false,
                  alertMessage: typeof error === 'string' ? error : 'The location could not be saved.'
                })
              }
            })
        }
      event.preventDefault();
    }
    
    handleChange = (event)=>{
      console.log(["event.valu:",event.target.value, event.target.name])
      switch(event.target.name){
          case "name":
          this.setState({
          nameValue:event.target.value
          })
          break;
        case "address":
          this.setState({
          address:event.target.value
          })
          break;
        case "latitude":
          this.setState({
          latitude:event.target.value
          })
          this.typedPin(event.target.value, this.state.longitude)
          break;
        case "longitude":
          this.setState({
          longitude:event.target.value
          })
          this.typedPin(this.state.latitude, event.target.value)
          break;
        }
      }

  // Typed coordinates that are a real spot move the pin there (and count as moving it)
  typedPin(latitude, longitude){
    const spot = typedSpot(latitude, longitude)
    if (spot) {
      this.setState({ markers: [this.pin(spot)], pinMoved: true })
      if (this.map) {
        this.map.setCenter(spot)
      }
      this.countryFromPin(spot)
    }
  }

	render() {
		const { latitude,longitude,address,locationId } = this.state;
    
		return <div>
			<Card>
          <Row className="toolbar up-card-title">
              <div className="b-title"><i className="ti-map-alt mr-10"></i>&nbsp;Location Details</div>
              {locationId!="null"?
                <a onClick={()=>this.props.history.push('/duty-location/'+locationId)}>
                <div className="b-title-end">View Location Duties&nbsp;<i className="ti-align-left"></i></div>
              </a>:<div></div>}
          </Row>
          <Row className="toolbar up-card-box">
              <div className="col-md-5">
                  <form name="myForm" onSubmit={this.onSave} onChangeCapture={markChanged(this)}>
                      <Row className="company-text-area">
                        <label htmlFor="address" className="col-md-3 control-label">Name</label>
                          <div className="col-md-9">
                              <input className="location-text-input" name="name" type="text" value={this.state.nameValue} onChange={this.handleChange} required></input>
                          </div>
                      </Row>
                      <Row className="company-text-area">
                        <label htmlFor="address" className="col-md-3 control-label">Country</label>
                          <div className="col-md-9">
                            <Select
                                styles={styles}
                                components={{ Option: CountryFlagSelectOption, ValueContainer: CountryFlagValueContainer }}
                                options={this.state.options}
                                value={this.state.countryValue}
                                onChange={this.changeCountry}
                              />
                              {this.state.countryNote ? <div className="country-note">{this.state.countryNote}</div> : null}
                          </div>
                      </Row>
                      {/* Worked out from the map pin without a word; a choice only when the country has several zones
                          and the pin does not decide it */}
                      <TimeZoneField row
                          country={this.state.countryValue ? this.state.countryValue.value : null}
                          latitude={this.state.latitude}
                          longitude={this.state.longitude}
                          value={this.state.timeValue ? this.state.timeValue.value : null}
                          onChange={(zone) => this.setState({ timeValue: zone ? { value: zone, label: zone } : '' })}
                        />
                      <Row className="company-text-area">
                        <label htmlFor="address" className="col-sm-3 control-label">Address</label>
                        <div className="col-md-9">
                            <textarea rows="3" className="form-control" id="address" name="address" value = {address} onChange={this.handleChange} ></textarea>
                        </div>
                      </Row>
                      <Row className="company-text-area">
                        <label htmlFor="address" className="col-md-3 control-label">Latitude</label>
                          <div className="col-md-9">
                              <input className="location-text-input" type="text" name="latitude" value= {latitude} onChange={this.handleChange} required></input>
                          </div>
                      </Row>
                      <Row className="company-text-area">
                        <label htmlFor="address" className="col-md-3 control-label">Longitude</label>
                          <div className="col-md-9">
                              <input className="location-text-input" name="longitude" type="text" value= {longitude} onChange={this.handleChange} required></input>
                          </div>
                      </Row>
                      <div className="height-10"></div>
                      <EditButtons changed={this.state.formChanged} onExit={this.exitForm} />
                  </form>
              </div>
              <div className="col-md-7 pd-20">
              <PlaceSearch google={this.props.google} map={this.state.map} onPlace={this.goToPlace} />
              <p style={{ width: "90%", margin: "0 auto 10px" }}>{PIN_HINT}</p>
              <div style={{ height: '500px', width: '100%' ,position:'relative'}}>
                {/* Opened and moved through the map itself (onMapReady): a center prop here re-centred it on every change */}
                <Map
                  google={this.props.google}
                  style={{ width: "90%", margin: "auto" }}
                  className={"map"}
                  zoom={2}
                  initialCenter={{ lat: 0, lng: 0 }}
                  onReady={this.onMapReady}
                  onClick={this.onPick}
                >
                  {this.state.markers.map((marker, index) => (
                    <Marker
                      key={index}
                      title={marker.title}
                      name={marker.name}
                      position={marker.position}
                      draggable={true}
                      onDragend={this.onPinDragged}
                    />
                  ))}
                </Map>
              </div>
              </div>
          </Row>
      </Card>
      <Modal isOpen={this.state.showAlert} toggle={this.toggle}>
			{/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					<h2>{this.state.alertMessage}</h2>
					<div className="height-10"></div>
					<FormGroup>
						<Button color="secondary" style={{width:'100px'}} className="ml-1" onClick={this.toggle}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" style={{width:'100px'}} onClick={this.toggle}>Ok</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
      <Modal isOpen={!!this.state.zoneMessage}>
        <ModalBody className="alert-body">
          <i className="mdi mdi-clock-alert ft-60"></i>
          <h4 className="zone-change-message">{this.state.zoneMessage}</h4>
          <div className="height-10"></div>
          <Button color="primary" onClick={this.exitForm}>OK</Button>
        </ModalBody>
      </Modal>
           
		</div>
	}
}

export default GoogleApiWrapper({
  apiKey:"AIzaSyAKXMyJn1D2_AnCvqiAt7JKj77ZTD7N4Ys"
})(CompanyView);
